import { queries } from "lib/build/dashboards/ltx/queries";
import { Origin } from "lib/build/events";

import { useLastEventByQuery } from "src/features/events";

export function usePatientEtId(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<string>(queries.patientEtId);
	return event === undefined
		? { value: "-" }
		: {
				value: event.value,
				timestamp: event.timestamp,
				origin: event.origin
			};
}
